import { observable, decorate, action } from 'mobx';
import InputStore from './InputStore';
import inputsConfig from '../configs/inputsConfig';
import CookieStore from "./CookieStore";
import axios from 'axios';


class AllInputsStore {
  inputs = {}
  isLoading = false

  constructor() {
    this.cookie = new CookieStore();
    this.loadInputs(this.cookie);
  }


  loadInputs(cookie) {
    this.isLoading = true;
    for(let key in inputsConfig) {
      this.inputs[key] = this.createInput(inputsConfig[key]);
      if(cookie.getCookie(key) !== undefined) {
        this.inputs[key].updateValue(cookie.getCookie(key));
      }
    }
    this.isLoading = false;
  }

  createInput(data) {
    const input = new InputStore(this, data);
    return input;
  }

  inputByName(name) {
    return this.inputs[name];
  }

  updateInput(event, isValid) {
    const name = event.target.name;
    const value = event.target.value;
    const input = this.inputs[name];
    if(!input) return null;
    input.isValid = isValid;
    input.updateValue(value);
  };

  handleChange(event) {
    const name = event.target.name;
    const input = this.inputs[name];
    if (!input) return null;
    const value = input.type === 'checkbox' ? event.target.checked : event.target.value;
    this.updateInputValue(name, value);
  };

  updateInputValue(name, value) {
    this.cookie.setCookie(name, value);
    this.inputs[name].updateValue(value);
  };

  checkAllInput() {
    for(let name in this.inputs) {
      if(!this.inputs[name].isValid) {
        return false;
      }
    }
    return true;
  }

}


decorate(AllInputsStore, {
  inputs: observable,
  isLoading: observable,
  updateInput: action.bound,
  handleChange: action.bound,
  updateInputValue: action.bound,
  updateInputWithMethod: action.bound,
  checkAllInput: action.bound
});

export default AllInputsStore;
